import React, { FunctionComponent } from 'react';
import { SectionSecondaryContent } from '../../Section/SectionSecondaryContent';
import { ArticlePartialModel } from '../../../services/content/article/models/ArticlePartialModel';

type Props = {
    articles: ArticlePartialModel[];
};

export const ArticleListing: FunctionComponent<Props> = ({ articles }) => {
    return (
        <div className='container px-0'>
            <div className='row'>
                {articles.map((article) => {
                    return (
                        <SectionSecondaryContent
                            key={`secondary-content-key-${article.id}`}
                            className={`col-md-4 col-12 mb-md-4`}
                            content={article}
                            category={article?.category}
                        />
                    );
                })}
            </div>
        </div>
    );
};
